import React, { useState, useEffect, useRef, Fragment } from "react";
import { useForm, Controller } from "react-hook-form";
import TableWrapper from "../../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import { Tooltip, Autocomplete, TextField } from "@mui/material";
import { MdModeEditOutline } from "react-icons/md";
import { callAPI } from "../../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../../core/BaseComponents/Modal";
import deleteImg from '../../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";
import { faImages, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FileUploader } from "react-drag-drop-files";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FaHotel } from "react-icons/fa";
import CarouselComponent from "./CarouselComponent ";
import DeleteBannerImage from "./DeleteBannerImage";
import CircularProgress from '@mui/material/CircularProgress';
// import Custom_Paingation from "../../../core/BaseComponents/Custom_Paingation";
import { ScrollToTop, getChainIdLS, isValidRole } from "../../../../utils/utils";
import { useSelector } from "react-redux";
import { SketchPicker } from "react-color";
import ClosedIcon from "@mui/icons-material/Close";
import ImageResolutionTooltip from "../../ConfigurationNewHotel/ImageResolutionTooltip";

function ConfigurationManagementForm() {
  const [bannerImagesList, setBannerImagesList] = useState({});
  const [confirmDeleteBannerRow, setConfirmDeleteBannerRow] = useState("");
  const [confirmValidate, setConfirmValidate] = useState(false);
  const [deleteBannerPopUp, setDeleteBannerPopUp] = useState(false);
  const [deleteBannerImagePopUpAPI, setDeleteBannerImagePopUpAPI] = useState(false);
  const [editBannerConfig, setEditBannerConfig] = useState(false);
  const [editBannerRowUpdate, setEditBannerRowUpdate] = useState(false);
  const [createBannerSuccessMsg, setCreateBannerSuccessMsg] = useState('');
  const [editBannerSid, setEditBannerSid] = useState("");
  const [fileError, setFileError] = useState("");
  const [files, setFiles] = useState([]);
  const [fileUrls, setFileUrls] = useState([]);
  const [originalFileUrls, setOriginalFileUrls] = useState([]);
  const [upLoadedFilesLength, setUpLoadedFilesLength] = useState(0);
  const [loader, setLoader] = useState(false);
  const [showPreviewPopUp, setShowPreviewPopUp] = useState(false);
  const [listConfigId, setListConfigId] = useState([]);
  const [previewBannerConfigIndex, setPreviewBannerConfigIndex] = useState(0);
  const [initialSlide, setInitialSlide] = useState(0);
  const [isEdit, setIsEdit] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    control
  } = useForm({
    mode: 'onChange',
  });

  let validPermissionClassName = isValidRole("DEFAULT_CONFIG_MODIFY")
    ? ""
    : "btn-disable-permission";

    const deafultHeroBannerImage = [
      {
        name: "Default Config Hero Banner Image",
        files: 15,
        size: "700 KB",
        height: 1080,
        width: 1920,
        resolution: "72 PPI",
        aspect: "16:09",
        formats: "JPG, JPEG, PNG",
      }
    ]
  
    const defaultHeroBannerChildImage = [
      {
        name: "Default Config Hero Banner Child Image",
        files: 1,
        size: "700 KB",
        height: 1080,
        width: 1920,
        resolution: "72 PPI",
        aspect: "16:09",
        formats: "JPG, JPEG, PNG",
      }
    ]

  const pickerStyle = {
    default: {
      picker: {
        backdrop: true,
        width: "260px",
        zIndex: "9999",
        position: "absolute",
        top: "-50px",
        left: "100%",
        padding: "25px 10px 0px",
      },
    },
  };

  const selectionTypeMaster = ["WEB_LINK", "YOUTUBE_LINK", "IMAGE"];
  const bannerCtaTextMaster = ["View Now", "Watch Now", "Play Now", "Open Now"];
  const textPositionMaster = ["Top Left", "Top Right", "Bottom Left", "Bottom Right", "Centered"];

  const textPostionClass = (selectedTextPosition) => {
    if (selectedTextPosition === "Top Left") {
      return 'top-left'
    } else if (selectedTextPosition === "Top Right") {
      return 'top-right'
    } else if (selectedTextPosition === "Centered") {
      return 'center'
    } else if (selectedTextPosition === "Bottom Right") {
      return 'bottom-right'
    }
    else if (selectedTextPosition === "Bottom Left") {
      return 'bottom-left'
    }
  }

  const onSubmit = (data) => {
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      let bytes = (file?.size / (1024)).toFixed(2);
      if (bytes > 700) {
        setFileError(`Upload file should be less than 700KB`);
        return;
      }
    };
    for (let i = 0; i < fileUrls.length; i++) {
      if (fileUrls[i]?.selectionType === "YOUTUBE_LINK" || fileUrls[i]?.selectionType === "WEB_LINK") {
        if (fileUrls[i]?.link === "") {
          setFileUrls(prev =>
            prev.map((item, index) =>
              index === previewBannerConfigIndex ? { ...item, linkError: "Please Enter Link" } : item
            )
          );
          return;
        } else if (fileUrls[i]?.linkError !== "") {
          return;
        }
      }else if(fileUrls[i]?.selectionType === "IMAGE"){
        if (fileUrls[i]?.link === "") {
          setFileUrls((prev) =>
            prev.map((item, index) =>
              index === previewBannerConfigIndex
                ? { ...item, linkError: "Please Upload Child Image" }
                : item
            )
          );
          return;
        } else if (fileUrls[i]?.linkError !== "") {
          return;
        }
      }
    }
    const formData = new FormData();
    let method = "POST";
    //?name=${data?.name}&roomTypes=${data?.roomTypes}&isPublish=true
    let url = `/hero-banner-default`;
    const payload = {}
    payload.name = data?.name
    if (editBannerRowUpdate) {
      const childImageTemp = fileUrls?.filter(item => !item?.delete)?.map(url => url?.childImages);

      childImageTemp.forEach(file => {
        if (file) {
          formData.append('childImagesForExistingImages', file);
        }
      });
      let updatedText = JSON.stringify(fileUrls?.filter(item => item.id).map(item => ({ imageId: item.id, text: item.text, textPosition: item.textPosition, selectionType: item.selectionType, link: item.link, newChildImage: ( item.hasOwnProperty("childImages") && item?.childImages!=='')?true:false, gradientColor: item.gradientColor, bannerCtaText: item.bannerCtaText })));
      payload.bannerConfigId= editBannerSid?.id;
      payload.existingHeroBannerRequest = JSON.parse(updatedText)
      payload.selectionType = fileUrls?.filter(item => !item.id).map(item => item.selectionType);
      payload.links = fileUrls?.filter(item => !item.id).map(item => item.link);
      payload.text = fileUrls?.filter(item => !item.id).map(item => item.text);
      payload.textPosition = fileUrls?.filter(item => !item.id).map(item => item.textPosition);
      payload.gradientColors = fileUrls?.filter(item => !item.id).map(item => item.gradientColor);
      payload.bannerCtaText = fileUrls?.filter(item => !item.id).map(item => item.bannerCtaText);
      // console.log(payload)
      formData.append('heroBannerUpdateRequest', new Blob([JSON.stringify(payload)], {type: 'application/json' }));
      Array.from(files).forEach((file) => {
        formData.append('newImages', file);
      });
      const childImageTemp1 = fileUrls?.filter(item => item?.delete)?.map((url)=>url?.childImages);
      childImageTemp1.forEach((file) => {
        formData.append('newChildImages', file);
      });
      method = "PUT"
      url = `/hero-banner-default`

      if (files.length + upLoadedFilesLength > 15) {
        setFileError(`${upLoadedFilesLength === 15 ? "Delete any of banner image to upload new banner image" : `${upLoadedFilesLength} of 15 banner images are already uploaded. You can only upload ${15 - upLoadedFilesLength} more image${(15 - upLoadedFilesLength) === 1 ? '' : 's'}`}`);
        return;
      }
      setFileError('');
    } else {
      if (files.length === 0) {
        setFileError('You must upload at least 1 file');
        return;
      } else if (files.length > 15) {
        setFileError('You can only upload up to 15 files');
        return;
      }
      setFileError('');
      setLoader(true);
      Array.from(files).forEach((file) => {
        formData.append('images', file);
      });
      const childImageTemp = fileUrls?.map((url)=>url?.childImages);
      childImageTemp.forEach((file) => {
        formData.append('childImages', file);
      });
      payload.selectionType = fileUrls?.map((url)=>url?.selectionType)
      payload.links = fileUrls?.map((url)=>url?.link)
      payload.text = fileUrls?.map((url)=>url?.text)
      payload.textPosition = fileUrls?.map((url)=>url?.textPosition)
      payload.gradientColors = fileUrls?.map(item => item.gradientColor);
      payload.bannerCtaText = fileUrls?.map(item => item.bannerCtaText);
      formData.append('heroBannerRequest', new Blob([JSON.stringify(payload)], {type: 'application/json'}));
    }

    callAPI(url, method, formData, { chainId: getChainIdLS() })
      .then(function (response) {
        setLoader(false);
        reset({
          name: '',
          roomTypes: []
        });
        setUpLoadedFilesLength(0);
        setLoader(false);
        reset({
          name: '',
          roomTypes: []
        });
        setFiles([]);
        setFileUrls([]);
        setCreateBannerSuccessMsg(response?.message);
        BannerListApi();
        setEditBannerSid('');
      })
      .catch(function (error) {
        setLoader(false);
        console.warn(error.response?.data?.errorMessage);
      });
  };

  // const onSave = (data) => {

  //   if (files.length === 0) {
  //     setFileError('You must upload at least 1 file');
  //     return;
  //   } else if (files.length > 15) {
  //     setFileError('You can only upload up to 15 files');
  //     return;
  //   }
  //   for (let i = 0; i < files.length; i++) {
  //     const file = files[i];
  //     let bytes = (file?.size / (1024)).toFixed(2);
  //     if (bytes > 700) {
  //       setFileError(`${file.name} file should be less than 700KB`);
  //       return;
  //     }
  //   };
  //   setFileError('');
  //   setLoader(true);
  //   const formData = new FormData();
  //   Array.from(files).forEach((file) => {
  //     formData.append('images', file);
  //   });
  //   const childImageTemp = fileUrls?.map((url)=>url?.childImages);
  //     childImageTemp.forEach((file) => {
  //       formData.append('childImages', file);
  //     });
  //     formData.append('selectionType', fileUrls?.map((url)=>url?.selectionType))
  //     formData.append('link', fileUrls?.map((url)=>url?.link))
  //     formData.append('text', fileUrls?.map((url)=>url?.text));
  //     formData.append('textPosition', fileUrls?.map((url)=>url?.textPosition));

  //   let url = `/config/create?name=${data?.name}&roomTypes=${data?.roomTypes}&isPublish=false`;

  //   callAPI(url, "POST", formData, { chainId: getChainIdLS() })
  //     .then(function (response) {
  //       setLoader(false);
  //       reset({
  //         name: '',
  //         roomTypes: []
  //       });
  //       setFiles([]);
  //       setFileUrls([]);
  //       setCreateBannerSuccessMsg(response?.message);
  //     })
  //     .catch(function (error) {
  //       setLoader(false);
  //       console.warn(error.response?.data?.errorMessage);
  //     });
  // };

  const isBannerDeletedRef = useRef({
    isBannerDeletedModalData: null,
    userConformationModalData: null,
  });

  const isPublishedUnPublishedRef = useRef({
    isPublishUnPublishModalData: null,
  });

  const isBannerImaageDeletedRef = useRef({
    isBannerImageDeletedModalData: null,
    deleteBannerConformationModalData: null
  });

  const deleteBannerRowPopUpHandler = (row) => {
    setDeleteBannerPopUp(true);
    const newModalRefData = {
      isBannerDeletedModalData: {
        row
      },
      userConformationModalData: null,
    };
    isBannerDeletedRef.current = newModalRefData;
  }

  const deleteBannerHandler = () => {
    setConfirmValidate(true);
    if (confirmDeleteBannerRow === "") {
      return
    }

    if (confirmDeleteBannerRow === `Delete Hero Banner ${isBannerDeletedRef.current?.isBannerDeletedModalData.row.configName}`) {
      setConfirmValidate(false)
      const { row } = isBannerDeletedRef.current?.isBannerDeletedModalData;
      callAPI(`/hero-banner-default?configId=${row?.id}`, "DELETE")
        .then((response) => {
          let successMessage = response.message
          const newModalRefData = {
            isBannerDeletedModalData: null,
            userConformationModalData: {
              successMessage
            },
          };
          isBannerDeletedRef.current = newModalRefData;
          cancelBannerHandler()
          BannerListApi();
        })
        .catch((error) => {
          console.warn(error)
        });
    }
    reset({
      name: '',
      roomTypes: []
    });
  }

  const deleteBannerImageHandlerApi = () => {
    const { bannerImage, bannerConfigId } = isBannerImaageDeletedRef.current?.isBannerImageDeletedModalData;
    callAPI(`/hero-banner-default/images/delete?bannerConfigId=${bannerConfigId}&imageId=${bannerImage?.id}`, "DELETE")
      .then((response) => {
        let successMessage = response.message
        const newModalRefData = {
          isBannerImageDeletedModalData: null,
          deleteBannerConformationModalData: {
            successMessage
          },
        };
        isBannerImaageDeletedRef.current = newModalRefData;
        BannerListApi();
      })
      .catch((error) => {
        console.warn(error)
      });
  }

  const renderActionIcon = (row) => {
    return (
      isValidRole("DEFAULT_CONFIG_MODIFY")?<>
          <Tooltip title="Edit" arrow>
            <MdModeEditOutline
              className="edit-icon-enable"
              onClick={() => { setEditBannerConfig(true); setEditBannerSid(row);  setIsEdit(true); }}
            />
          </Tooltip>
          <Tooltip title="Delete" className="cursor-pointer" arrow>
            <DeleteIcon
              className="delete-icon-enable"
              onClick={() => {
                deleteBannerRowPopUpHandler(row);
              }}
            />
          </Tooltip>
        </>:
        <>
        <Tooltip title="Don't have permission to edit">
          <span>
            <MdModeEditOutline className="edit-icon-disable" arrow />
          </span>
        </Tooltip>
        <Tooltip title="Don't have permission to delete">
          <DeleteIcon className="delete-icon-disable" arrow />
        </Tooltip>
      </>
    );
  };

  const renderConfigImages = (row) => (
    <div className="delete-config-images">
      {row?.bannerImage?.slice(0, 4)?.map((url, index) => (
        <div key={url?.id}>
          <img src={url?.url} alt={url?.id} onClick={() => BannerPreviewHandler(row?.id, index)} />
          {/* {!row?.published ? <Tooltip title={`${row?.bannerImage?.length === 1 ? 'At least one image required in hero banner' : editBannerSid?.id === row?.id ? 'Cancel edit mode to perform actions' : 'Delete'}`}>
            <span className={`${row?.bannerImage?.length === 1 || editBannerSid?.id === row?.id ? 'cross-mark-disabled' : 'cross-mark-enabled'}`} onClick={() => row?.bannerImage?.length === 1 || editBannerSid?.id === row?.id ? "" : handleDeleteBannerAPI(url, row?.id)}>X</span></Tooltip> : <Tooltip title="Un-Publish to perform actions"><span className="cross-mark-disabled">X</span></Tooltip>} */}
        </div>
      ))}
      {row?.bannerImage?.length>4 && <span>...<span onClick={() => BannerPreviewHandler(row?.id, 0)} className="ms-2 cdsn-count">+{row?.bannerImage?.length-4}</span></span>}
    </div>
  )


  const columns = [
    { field: "createdOn", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
    { field: "configName", headerName: "Config Name", flex: 1 },
    { field: "bannerImage", headerName: "Banner Images", flex: 1, row: true, renderCell: renderConfigImages, flex: 0.5, disableSortIcon: true, },
    {
      field: "actionCell",
      row: true,
      headerName: "Actions",
      flex: 0.5,
      renderCell: renderActionIcon,
      sortDirection: false,
      disableSortIcon: true,
    },
  ];

  const BannerListApi = () => {
    const apiPath = `/hero-banner-default`;
    callAPI(apiPath, "GET")
      .then((response) => {
        setBannerImagesList(response)
        // setTotalPageCount(response?.totalPages ? response?.totalPages : 1)
        // setPaginationError("")
      })
      .catch((err) => console.warn(err.message));
       setIsEdit(false);
  };

  useEffect(() => {
    BannerListApi();
  }, []);

  const popupCloseHandler = () => {
    setDeleteBannerPopUp(false);
    // setPublishUnPublishPopUp(false);
    setDeleteBannerImagePopUpAPI(false);
  };

  useEffect(() => {
    if (editBannerConfig) {
      getBannerListSidHandler();
      setEditBannerConfig(false);
    }
    ScrollToTop();
  }, [editBannerConfig]);

  const getBannerListSidHandler = () => {
    callAPI(`/hero-banner-default/${editBannerSid?.id}`, "GET")
      .then(function (response) {
        const payload = {
          name: response?.configName,
          roomTypes: response.roomTypes
        };
        setFileUrls(response?.bannerImage?.map(item => ({ ...item, gradientColor: item.gradientColor?item.gradientColor:'000000', delete: false, linkError: '' })));
        setOriginalFileUrls(response?.bannerImage?.map(item => ({ ...item, gradientColor: item.gradientColor?item.gradientColor:'000000', delete: false, linkError: '' })))
        setFiles([]);
        setUpLoadedFilesLength(response?.bannerImage.length)
        reset(payload);
        setEditBannerRowUpdate(true);
        setFileError("");
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
      });
  }

  const resetLayoutHandler = () => {
    reset();
    setFileUrls(originalFileUrls);
    setFiles([]);
  }

  const cancelBannerHandler = () => {
    reset({
      name: '',
      roomTypes: []
    });
    setFileUrls([]);
    setFiles([]);
    setEditBannerRowUpdate(false);
    setEditBannerSid('');
    setEditBannerConfig(false);
    setFileError("");
    setUpLoadedFilesLength(0);
    setIsEdit(false);
  }

  const uploadOrDragFileHandler = (fileList) => {
    const selectedFiles = Array.from(fileList);
    setFiles((prev) => [...selectedFiles, ...prev]);
    const urls = selectedFiles.map(file => ({ url: URL.createObjectURL(file), delete: true, showColorPanel: false, gradientColor: "000000", link: '', linkError: '', selectionType: '', text: '', textPosition: '', childImages: '',bannerCtaText: "View Now" }));
    setFileUrls((prev) => [...urls, ...prev]);
    setFileError('');
  }

  const handleDeleteBanner = (index) => {
    // Revoke the object URL for the deleted file
    URL.revokeObjectURL(fileUrls[index]);

    // Update the state
    const newFiles = files.filter((_, i) => i !== index);
    const newFileUrls = fileUrls.filter((_, i) => i !== index);
    setPreviewBannerConfigIndex(index ? index - 1 : 0);
    setFiles(newFiles);
    setFileUrls(newFileUrls);
  };

  const handleDeleteChildImage = (index) => {
    const update = fileUrls?.map((urlObject, i) => {
      if (i === index) {
        return {
          ...urlObject,  // Spread existing properties
          // childImageUrl: '',
          childImages: '',
          link: '',
        };
      }
      return urlObject; // Return the original object for other indices
    });
    setFileUrls(update);
  };

  const handleDeleteBannerAPI = (banner, bannerConfigId) => {
    setDeleteBannerImagePopUpAPI(true);
    const newModalRefData = {
      isBannerImageDeletedModalData: {
        bannerImage: banner,
        bannerConfigId: bannerConfigId
      },
      deleteBannerConformationModalData: null
    };
    isBannerImaageDeletedRef.current = newModalRefData;

  }

  const BannerPreviewHandler = (configId, index) => {
    setShowPreviewPopUp(true);
    setListConfigId(configId);
    setInitialSlide(index)
  }

  const handleMetadataChange = (value, keyName) => {
    if(keyName === "childImages"){
      setFileUrls(prev =>
        prev.map((item, index) =>
          index === previewBannerConfigIndex ? { ...item, [keyName]: value, link: URL.createObjectURL(value), linkError:'' } : item
        )
      );
    }
    else if(keyName === "selectionType"){
      const fileUrlsObje = JSON.parse(JSON.stringify(fileUrls));
      let regexError;
      fileUrlsObje.map((item, index) => {
        if (index === previewBannerConfigIndex) {
          if (value === 'YOUTUBE_LINK' && item?.link === "") {
            regexError = "Please Enter Link"
          } else if (value === 'WEB_LINK' && item?.link === "") {
            regexError = "Please Enter Link"
          }else if (value === "IMAGE" && item?.link === "") {
            regexError = "Please Upload Child Image";
          } else {
            regexError = ""
          }
        }
      })
      setFileUrls(prev =>
        prev.map((item, index) =>
          index === previewBannerConfigIndex ? { ...item, [keyName]: value, childImages: '', link : '', linkError: regexError} : item
        )
      );
    }
    else if(keyName === "text"){
      setFileUrls(prev =>
        prev.map((item, index) =>
          index === previewBannerConfigIndex ? { ...item, [keyName]: value, textPosition: item?.textPosition?.length>2?item?.textPosition: 'Centered' } : item
        )
      );
    }
    else{
      if(keyName==='link'){
      const fileUrlsObje = JSON.parse(JSON.stringify(fileUrls));
      let regexError;
      fileUrlsObje.map((item, index) => {
        if (index === previewBannerConfigIndex) {
          if (item.selectionType === 'YOUTUBE_LINK') {
            let regex = /^(https?:\/\/(www\.)?(youtube\.com\/|youtu\.be\/)([^\s]*)$)/;
            if (value.length > 0) {
              if (!regex.test(value)) {
                regexError = "URL must start with https://www.youtube.com/ or https://youtu.be/";
              } else if(value.length > 255) {
                regexError = "Maximum 255 charaters allowed for URLs";
              } else {
                regexError = "";
              }
            } else {
              regexError = "Please Enter Link";
            }
          } else if (item.selectionType === 'WEB_LINK') {
            let regex = /^(https:\/\/www\.|http:\/\/www\.)/;
            if (value.length > 0) {
              if (!regex.test(value)) {
                regexError = "URL must start with http://www. or https://www.";
              } else if(value.length > 255) {
                regexError = "Maximum 255 charaters allowed for URLs";
              } else {
                regexError = "";
              }
            } else {
              regexError = "Please Enter Link";
            }
          }
        }
      })
      setFileUrls(prev =>
        prev.map((item, index) =>
          index === previewBannerConfigIndex ? { ...item, [keyName]: value, linkError: regexError } : item
        )
      );
    }else{
      setFileUrls(prev =>
        prev.map((item, index) =>
          index === previewBannerConfigIndex ? { ...item, [keyName]: value } : item
        )
      );
    }
    }
  }

  return (
    <div className='row config-hotel config-management-form mx-0'>
      <div className='col-12 left-column px-0'>
        {loader && <div className="circular-progress"><CircularProgress /></div>}
        <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} className={`hotel-list-form ${isEdit ?"":bannerImagesList?.length ?"page-mask":""} `}>
          {bannerImagesList?.length>0 && !isEdit && <div className='mask-content default-config'>Only one default configuration can be created at a time. <br/> Please update existing one if required.</div> }
          <div className="row">
            <div className="left-column-header">
              <p>{editBannerRowUpdate ? 'Edit Configuration Management Details' : 'Add Configuration Management Form'}</p>
            </div>
            <div className="form-group-hotel col-4">
              <div className="floating-label">
                <FaHotel className="new-hotel-icons" />
                <input
                  id="name"
                  maxLength={40}
                  placeholder=""
                  {...register("name", {
                    required: "Enter Configuration Name",
                  })}
                />
                <label htmlFor="name">Enter Configuration Name</label>
              </div>
              {errors.name && (
                <small className="required">{errors.name.message}</small>
              )}
            </div>
            <div className="form-group-hotel col-12">
              <p className="banner-title">{editBannerRowUpdate ? 'Edit' : 'Add'} Hero Banner Image</p>
              <div className="row mx-0">
                {fileUrls?.length > 0 && <div className="col-9 upload-img">
                  <img src={fileUrls[previewBannerConfigIndex]?.url} alt={fileUrls[previewBannerConfigIndex]?.url} />
                </div>}
                <div className={`${fileUrls.length > 0 ? 'col-3 file-upload-bg' : 'col-12 file-upload'}`}>
                  <FileUploader
                    name="file"
                    types={["JPG", "PNG", 'JPEG']}
                    multiple={true}
                    handleChange={uploadOrDragFileHandler}
                    classes="drag-file"
                    children={
                      <>
                        <FontAwesomeIcon icon={faImages} className="fa-lg" />
                        <p className="drag-text">
                          Drag and drop your file's here, or
                          <span> Browse</span>
                          <br />
                          To {editBannerRowUpdate ? "Add New" : "Upload"} Banner Images.
                        <ImageResolutionTooltip data={deafultHeroBannerImage}/>
                        </p>
                        {/* <h6>Max file allowed : 15 {fileError === "" && "and Max File Size: 700 KB"} <br /> Formats Supported : JPG, JPEG and PNG</h6> */}
                      </>
                    }
                  />
                  {fileError && <p className="required">{fileError}</p>}
                </div>
              </div>
              <div className="upload-img_url">
                {fileUrls?.map((url, index) =>
                  <div key={index}>
                    <img src={url?.url} alt={url?.url} onClick={() => setPreviewBannerConfigIndex(index)} className={`${fileUrls[previewBannerConfigIndex]?.url === url?.url ? 'selected-image' : ''}`} />
                    {url?.delete &&<span onClick={() => handleDeleteBanner(index)}>X</span>}
                  </div>
                )}
              </div>
              {fileUrls?.length > 0 && <>
                {fileUrls?.map((url, index) =>
                  <Fragment>
                    {fileUrls[previewBannerConfigIndex]?.url === url?.url && <div key={index} className="row mx-0 my-3">
                    <div className="col-2 position-relative">
                            {url.showColorPanel && (
                              <>
                                <SketchPicker
                                  styles={pickerStyle}
                                  color={`#${url.gradientColor}`}
                                  onChange={(updatedColor) =>
                                    handleMetadataChange(
                                      updatedColor.hex.slice(1),
                                      "gradientColor"
                                    )
                                  }
                                />
                                <ClosedIcon
                                  fontSize={"2px"}
                                  className={`cursor-pointer close-icon color-picker-cross-mark }`}
                                  onClick={() =>
                                    handleMetadataChange(
                                      !url.showColorPanel,
                                      "showColorPanel"
                                    )
                                  }
                                />
                              </>
                            )}

                            <div
                              className="sketch-color-picker"
                              style={{ background: `#${url.gradientColor}` }}
                              onClick={(e) => {
                                e.preventDefault();
                                handleMetadataChange(
                                  !url.showColorPanel,
                                  "showColorPanel"
                                );
                              }}
                            >
                              <label htmlFor="name">Gradient Color</label>
                              <div className="picker-shadow">
                                <FontAwesomeIcon icon={faPencilAlt} />
                              </div>
                            </div>
                            {/* {(color===""&&validateForm)&&<p className="validationerror">Note: Please select thick color for clear visibility on dashboard</p>} */}
                          </div>
                          <div className="col-3">
                      <div className="floating-select-label">
                            <Controller
                              name="bannerCtaText"
                              control={control}
                              render={({ field }) => (
                                <Autocomplete
                                  {...field}
                                  className={`multiselectlist ${url?.bannerCtaText && url?.bannerCtaText.length > 0 ? 'Mui-focused' : ''}`}
                                  disablePortal
                                  options={bannerCtaTextMaster}
                                  getOptionLabel={(option) => option.toString()}
                                  onChange={(_, newValue) => {
                                    field.onChange(newValue);
                                    handleMetadataChange(newValue, "bannerCtaText")
                                  }}
                                  value={url?.bannerCtaText}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder=""
                                      variant="outlined"
                                      label="Banner CTA Text"
                                      InputLabelProps={{
                                        shrink: false,
                                      }}
                                    />
                                  )}
                                />
                              )}
                            />
                          </div>
                      </div>
                        <div className="col-3">
                          <div className="">
                            <div className="floating-select-label">
                              <Controller
                                name="selectionType"
                                control={control}
                                render={({ field }) => (
                                  <Autocomplete
                                    {...field}
                                    className={`multiselectlist ${url?.selectionType && url?.selectionType.length > 0 ? 'Mui-focused' : ''}`}
                                    disablePortal
                                    options={selectionTypeMaster}
                                    getOptionLabel={(option) => option.toString()}
                                    onChange={(_, newValue) => {
                                      field.onChange(newValue);
                                      handleMetadataChange(newValue, "selectionType")
                                    }}
                                    value={url.selectionType ? url.selectionType : ' '}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder=""
                                        variant="outlined"
                                        label="Selection Type"
                                        InputLabelProps={{
                                          shrink: false,
                                        }}
                                      />
                                    )}
                                  />
                                )}
                              />
                            </div>
                          
                          </div>
                          {url.selectionType=="IMAGE" && <div className="py-3">
                              <div className="floating-label">
                                {/* <FaHotel className="new-hotel-icons" /> */}
                                <input
                                  type="text"
                                  value={url.text ? url.text : ""}
                                  id={url.id}
                                  maxLength={255}
                                  onChange={(e) => handleMetadataChange(e.target.value, "text")}
                                />
                                <label htmlFor="name">Enter Banner text</label>
                              </div>
                          </div>}
                          {url.selectionType=="IMAGE" && <div className="">
                              <div className="floating-select-label">
                                <Controller
                                  name="textPosition"
                                  control={control}
                                  // rules={{
                                  //   validate: (value) => (value !== undefined && value !== null && value !== '') || 'Please Select Text Position'
                                  // }}
                                  render={({ field }) => (
                                    <Autocomplete
                                      {...field}
                                      className={`multiselectlist ${url?.textPosition && url?.textPosition.length > 0 ? 'Mui-focused' : ''}`}
                                      // limitTags={2}
                                      disablePortal
                                      // multiple
                                      options={textPositionMaster}
                                      getOptionLabel={(option) => option.toString()}
                                      onChange={(_, newValue) => {
                                        field.onChange(newValue);
                                        handleMetadataChange(newValue, "textPosition")
                                      }}
                                      value={url.textPosition ? url.textPosition : ' '}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          placeholder=""
                                          variant="outlined"
                                          label="Select Text Position"
                                          InputLabelProps={{
                                            shrink: false,
                                          }}
                                        />
                                      )}
                                    />
                                  )}
                                />
                              </div>
                          </div>}
                        </div>
                        <div className="col-4">
                          {(url.selectionType=="YOUTUBE_LINK" || url.selectionType=="WEB_LINK") && <div className="px-0">
                              <div className="floating-label">
                                <input
                                  type="link"childImages
                                  value={url.link ? url.link : ""}
                                  id={url.id}
                                  onChange={(e)=>handleMetadataChange(e.target.value, "link")}
                                />
                                <label htmlFor={url.id}>Enter Link</label>
                              </div>
                              {url?.linkError !== "" && (
                            <small className="required">{url?.linkError}</small>
                          )}
                            </div>}
                            {/* {console.log(fileUrls)} */}
                          { (url.selectionType=="IMAGE" && fileUrls[previewBannerConfigIndex]?.link?.length>0) && <div className="partner-logo upload-img px-0"><img style={{height: "150px"}} className="" src={fileUrls[previewBannerConfigIndex]?.link} alt={fileUrls[previewBannerConfigIndex]?.link} /><p className={textPostionClass(fileUrls[previewBannerConfigIndex]?.textPosition)}><label>{fileUrls[previewBannerConfigIndex]?.text}</label></p><span onClick={() => handleDeleteChildImage(index)}>X</span></div>}
                            {(url.selectionType=="IMAGE" && fileUrls[previewBannerConfigIndex]?.link?.length<1 ) && <><div style={{height: "150px"}} className='file-upload-bg'>
                            <FileUploader
                              name="childImages"
                              types={["JPG", "PNG", 'JPEG']}
                              // multiple={true}
                              handleChange={(value)=>handleMetadataChange(value, "childImages")}
                              classes="drag-file px-0"
                              children={
                                <>
                                  {/* <FontAwesomeIcon icon={faImages} className="fa-lg" /> */}
                                  <p className="drag-text my-0">
                                    Drag and drop your image here, or
                                    <span> Browse</span>
                                    <br />
                                    To {editBannerRowUpdate ? "Add New" : "Upload"} Child Image.
                                  <ImageResolutionTooltip data={defaultHeroBannerChildImage}/>
                                  </p>
                                  {/* <p className="drag-text my-0">{"Max File Size: 700 KB & Min File Size: 200 KB"} <br/> Formats Supported : JPG, JPEG and PNG</p> */}
                                </>
                              }
                            />
                          </div>
                            {url?.linkError !== "" && (
                              <small className="required">
                                {url?.linkError}
                              </small>
                            )}
                            </>
                          }
                        </div>
                    </div>}
                  </Fragment>
                )}
              </>}
            </div>

            <div className="text-end">
              <div>
                <button type="button" className="clear-btn me-2" onClick={cancelBannerHandler}>{editBannerRowUpdate ? "Cancel" : "Clear All"}</button>
                {editBannerRowUpdate && <>
                  <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
                </>}
                {/* {!editBannerRowUpdate && <button type="button" disabled={isSubmitting} className="disable-btn me-2" onClick={handleSubmit(onSave)}>Save</button>} */}
                <button type="button" disabled={isSubmitting} className={`create-btn ${validPermissionClassName}`} onClick={handleSubmit(onSubmit)}>{editBannerRowUpdate ? "Update" : "Save"}</button>
              </div>
            </div>
          </div>
        </form>
        <div className="hotel-list">
          <p><b>Configuration List</b></p>
          <TableWrapper
            data={bannerImagesList?.length?bannerImagesList:[]}
            columns={columns}
            module="banner-config"
            noPagination={true}
          />
          {/* <Custom_Paingation
            selectedPage={selectedPage}
            totalPageCount={totalPageCount}
            paginationError={paginationError}
            inputPageValue={inputPageValue}
            setSelectedPage={setSelectedPage}
            setPaginationError={setPaginationError}
            setInputPageValue={setInputPageValue}
            onPageChange={onPageChange}
          /> */}
        </div>

      </div>
      {showPreviewPopUp && <CarouselComponent
        showPreviewPopUp={showPreviewPopUp}
        listConfigId={listConfigId}
        setShowPreviewPopUp={setShowPreviewPopUp}
        initialSlide={initialSlide}
        BannerListApi={BannerListApi}
        handleDeleteBannerAPI={handleDeleteBannerAPI}
        editBannerSid={editBannerSid}
      />}
      <DeleteBannerImage
        deleteBannerImagePopUp={deleteBannerImagePopUpAPI}
        popupCloseHandler={popupCloseHandler}
        deleteBannerImageHandlerApi={deleteBannerImageHandlerApi}
        isBannerImaageDeletedRef={isBannerImaageDeletedRef}
      />
      {/* <ConfigrationActions /> */}
      <BasicModal
        popupOpen={deleteBannerPopUp}
        bodyMessage={<>
          <img src={deleteImg} alt="approve" className="w-40px" />
          <div className="delete-hotel mb-3">{isBannerDeletedRef.current?.isBannerDeletedModalData ?
            <div className="confirm-delete-hotel">
              <p>Do you really want to Delete Hero Banner "<b>{isBannerDeletedRef.current?.isBannerDeletedModalData.row.configName}</b>" ?</p>
              <p className="warning"><IoMdWarning /> Warning</p>
              <p>Hero Banner "{isBannerDeletedRef.current?.isBannerDeletedModalData.row.configName}" will be permanently deleted <br />
                Deleting the specified Hero Banner can't be undone.
              </p>
              <p className="mt-3">To confirm deletion, type "Delete Hero Banner {isBannerDeletedRef.current?.isBannerDeletedModalData.row.configName}"</p>
              <div className="form-group-hotel mt-3">
                <div className="floating-label">
                  <input
                    id="deleteHotel"
                    // maxLength={30}
                    placeholder=''
                    onChange={(e) => setConfirmDeleteBannerRow(e.target.value)}
                  />
                  <label htmlFor="deleteHotel">Delete Hero Banner</label>
                </div>
                {(confirmDeleteBannerRow === "" && confirmValidate) ? (
                  <p className="text-start"><small className="required">Please Enter Delete Hero Banner{isBannerDeletedRef.current?.isBannerDeletedModalData.row.configName}</small></p>
                ) : (confirmDeleteBannerRow !== `Delete Hero Banner ${isBannerDeletedRef.current?.isBannerDeletedModalData.row.configName}` && confirmValidate) ? (
                  <p className="text-start"><small className="required">Please Enter Delete Hero Banner {isBannerDeletedRef.current?.isBannerDeletedModalData.row.configName}</small></p>
                ) : ""
                }
              </div>
            </div> :
            isBannerDeletedRef.current?.userConformationModalData?.successMessage}</div>
        </>
        }
        footer={
          isBannerDeletedRef.current?.isBannerDeletedModalData ?
            {
              primaryButton: {
                buttonName: "Cancel",
                action: popupCloseHandler
              }
              ,
              secondaryButton: {
                buttonName: "Delete",
                action: deleteBannerHandler
              }
            } : {
              secondaryButton: {
                buttonName: "OK",
                action: popupCloseHandler
              }
            }
        }
      />

      <BasicModal
        popupOpen={createBannerSuccessMsg !== ""}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">{createBannerSuccessMsg}</p>}
        // customcss={true}
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => { setCreateBannerSuccessMsg(''); setEditBannerRowUpdate(false); BannerListApi(); },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />

    </div>
  )
}

export default ConfigurationManagementForm;